import gql from 'graphql-tag'

export const fetchProductQuery = gql`
  query ($sku: String) {
    products(filter: { sku: { eq: $sku } }, pageSize: 25, currentPage: 1, sort: { catalog_product_name: ASC }) {
      items {
        high_markets_discount
        material_type
        number_of_items_in_box
        packaging_enable
        deliveryDate
        sku
        number_of_products_on_layer
        product_reco_tags {
          value
          label
          color
        }
        description {
          html
        }
        ean
        ean_ea
        your_price
        your_price_tax
        downloads
        favourites
        promo
        weight
        gross_weight_for_one_cas
        other_info_gross_weight
        sap_sub_brand_code
        features {
          fermentation
          beer_type
          province
          taste
          custom_color
          alcohol_content
          food_pairing
          conservation_term
          service_temperature
        }
        technical {
          package_dimensions
          pallet_dimensions
          pallet_weight
          gross_weight_for_one_cas
        }
        saleability{
          sellable
          disabled_from
          disabled_to
        }
        packaging
        options_container
        beer_type
        number_of_layers_per_pallet
        number_of_items_on_pallet
        number_of_products_on_layer
        product_name_sap
        sku_product_detail_page
        brand
        hectolitres_for_one_cas_frontend
        hectolitres_per_pallet
        other_info_shelf_life
        pack_format
        pack_material
        sap_pack
        sap_pack_configuration
        returnable_package
        sub_brand
        volume
        country_of_origin
        catalog_product_name
        name
        filter_packaging
        product_last
        product_new
        product_sale
        product_recommended
        product_seasonal
        canonical_url
        url_path
        url_key
        url_rewrites {
          url
          parameters {
            name
            value
          }
        }
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
          }
        }
        small_image {
          url
        }
        thumbnail {
          url
        }
        image {
          url
        }
        media_gallery {
          url
        }
        related_products {
          high_markets_discount
          uid
          name
          sku
          price_range {
            minimum_price {
              final_price {
                value
                currency
              }
            }
            maximum_price {
              final_price {
                value
                currency
              }
            }
          }
          small_image {
            url
          }
          thumbnail {
            url
          }
          image {
            url
          }
          media_gallery {
            url
          }
        }
      }
      page_info {
        page_size
      }
    }
  }
`
